<template>
  <div>
    <div class="styled-input">
    <div class="styled-input wide">
      <textarea style="border: 1px solid #eee;" required v-model="answer"></textarea>
      <label>Write Your Answer</label>
      <span></span> </div>
    </div>
    <div class="view-tracker" style="text-align:center;margin-right: -15px; margin-left: -15px;">
      <button
              style="background-color: rgb(251, 176, 59);
  border-radius: 50px;
  color: #F9FAFF;
  padding: 0;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  flex-direction: column;
  max-width: 10rem;
  width: 100%;
  padding: 0.5rem 1rem;
  border: 0;
  font: inherit;
  font-weight: 600;
  text-transform: uppercase;
  transition: transform 100ms linear;
  border: 1px solid transparent;max-width: 15rem;margin:auto;background-color: #fbb03b;"
              title="Submit Answer"
              @click.prevent="submitAnswer"
      >Submit Answer</button>
    </div>
  </div>
</template>

<script>
  import Button from "../general/Button";
  export default{
    components: {
      "n-button": Button
    },
    props:{
      question_id:{
        type: Number,
        required: true
      }
    },
    data(){
      return{
        answer:''
      }
    },
    methods: {
      submitAnswer(){
        this.$emit('answered',true);
        this.$store.commit('pauseGame', 'pause');
        this.$store.commit('score', {last_question:this.$store.state.round+1,time:0,false: false,score:0,answer:this.answer,question_id:this.question_id});
      }
    }
  }
</script>
<style scoped>
  input:focus ~ label, textarea:focus ~ label, input:valid ~ label, textarea:valid ~ label {
    font-size: 0.75em;
    color: #8e44ad;
    top: -2.25rem;
    -webkit-transition: all 0.125s ease;
    transition: all 0.125s ease;
  }

  .styled-input {
    float: left;
    width: 86%;
    margin: 2rem 25px 1rem;
    position: relative;
  }

  .styled-input label {
    color: #999;
    padding: 1rem;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-transition: all 0.25s ease;
    transition: all 0.25s ease;
    pointer-events: none;
  }

  .styled-input.wide {    margin: auto;
    width: 100%; }

  input,
  textarea {
    padding: 1rem 1rem;
    border: 0;
    width: 100%;
    font-size: 1rem;
  }

  input ~ span,
  textarea ~ span {
    display: block;
    width: 0;
    height: 3px;
    background: #8e44ad;
    position: absolute;
    bottom: 0;
    left: 0;
    -webkit-transition: all 0.125s ease;
    transition: all 0.125s ease;
  }

  input:focus,
  textarea:focus { outline: 0; }

  input:focus ~ span,
  textarea:focus ~ span {
    width: 100%;
    -webkit-transition: all 0.075s ease;
    transition: all 0.075s ease;
  }

  textarea {
    width: 100%;
    min-height: 8em;
  }
</style>
